var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"soluciones_nedetel"},[_c('NavBar',{on:{"updateSection":_vm.updateSection}}),_c('Portada'),_c('div',{staticClass:"div_to_scrool",attrs:{"id":"div_to_scrool"}}),_c('Sections',{attrs:{"section_active":_vm.section_active}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }